import React from "react";
import Layout from "../../components/user/Layout";
import ProductDetails from "../../components/user/ProductDetails";
import { useParams } from "react-router-dom";
import ShopSection from "../../components/ShopSection";
import BannerCategoryProductList from "../../components/user/BannerCategoryProductList";

const BannerCategoryProductListPage = () => {
  const { categoryID } = useParams();

  return (
    <>
      <Layout>
        <BannerCategoryProductList categoryID={categoryID} />
      </Layout>
    </>
  );
};

export default BannerCategoryProductListPage;
